/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IActionRefItem, IActionRefResolver, TSchemaConstObjectProps } from "@adapptio/lib-blueprint";
import { createEventEmitter, TSimpleEventEmitter } from "@adapptio/lib-shared";
import { IResourceRegistry } from "../registries";
import { IActionResourceProps } from "../resources";

/**
 * Action Ref Resolver
 */
export class ActionRefResolver implements IActionRefResolver {
	/**
	 * Invalidate event - emitted when action list has changed (and param schemas must be re-resolved)
	 */
	public onInvalidate: TSimpleEventEmitter<void>;

	/**
	 * Constructor
	 */
	public constructor(protected resourceRegistry: IResourceRegistry) {
		this.onInvalidate = createEventEmitter();
	}

	/**
	 * Returns a params schema by action ID
	 */
	public getParamsSchemaById(actionId: string): TSchemaConstObjectProps {
		const action = this.resourceRegistry
			.getItemList()
			.filter((resource) => resource.id === actionId)[0] as IActionResourceProps;

		if (action) {
			return action.parsedData.paramsSchemaImport.constSchema.opts.props;
		} else {
			return null;
		}
	}

	/**
	 * Returns a list of available actions
	 */
	public getActionList(): IActionRefItem[] {
		return;
	}
}
